/**
 * Filtr opsiyalari tarjimasi (BD dagi kanonik qiymatlar).
 */
export default {
  'Продажа': 'Sotiladi',
  'Аренда': 'Ijaraga',
  'Аренда долгосрочная': 'Uzoq muddatli ijara',
  'Обмен': 'Almashinuv',
  'Квартиры': 'Kvartiralar',
  'Дома': 'Uylar',
  'Земля': 'Yer',
  'Гаражи / стоянки': 'Garajlar / to\'xtash joylari',
  'Коммерческие помещения': 'Tijorat joylari',
  'От застройщика': 'Quruvchidan',
}
